import { Sites } from '@ps/platform-message-framework/common/Sites';
import type { LabelProp } from '@ps/web-shared-components';
import React from 'react';
import { Field } from 'react-final-form';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import Checkbox from '../../../Checkbox/Checkbox';

import {
  TXTMOB_I_consent_to_receive_details_o_ELL,
  TXTWCL_Email_me_about_special_offers__ELL
} from './MarketingMailList.messages.json';

const fieldName = 'marketingMailList';

const absentCheckBoxCountryList = [Sites.BEL];
const detailedLabelCountryList = [Sites.EST, Sites.DE];

const detailedLabel = (siteId: Sites | undefined): LabelProp =>
  siteId && detailedLabelCountryList.includes(siteId)
    ? TXTMOB_I_consent_to_receive_details_o_ELL
    : TXTWCL_Email_me_about_special_offers__ELL;

const MarketingMailList: React.FunctionComponent = () => {
  const siteId = useSelector(select.cms.getSiteId);
  if (absentCheckBoxCountryList.includes(siteId)) {
    return null;
  }

  return (
    <Field name={fieldName} type="checkbox">
      {({ input: { onChange, checked } }) => (
        <Checkbox
          checked={checked}
          name={fieldName}
          onChange={onChange}
          label={detailedLabel(siteId)}
        />
      )}
    </Field>
  );
};

export default MarketingMailList;
